// Environment-specific configuration
const currentHostname = window.location.hostname;
const currentProtocol = window.location.protocol;
const wsProtocol = currentProtocol === 'https:' ? 'wss:' : 'ws:';
const ENV = window.location.hostname.includes('localhost') ? 'development' : 'production';



const CONFIG = {
  development: {
    BASE_URL: 'http://localhost:3000', // Local proxy URL
    WSS_URL: 'wss://web.stockkida.com',   // WebSocket URL
    USE_PROXY: true,
    ASSETS_URL: '/',
  },
  staging: {
    BASE_URL: `${currentProtocol}//${currentHostname}`,
    WSS_URL: `${wsProtocol}//${currentHostname}`,
    USE_PROXY: false,
    ASSETS_URL: '/',
  },
  production: {
    BASE_URL: `${currentProtocol}//${currentHostname}`,
    WSS_URL: `${wsProtocol}//${currentHostname}`,
    USE_PROXY: false,
    ASSETS_URL: '/',
  }
};


export const API_CONFIG = {
  ...CONFIG[ENV],
  ENDPOINTS: {
    // Authentication
    LOGIN: '/api/v4/user/login',
    VERIFY_2FA: '/api/v4/user/twofa',
    RESET_PASSWORD: '/api/v1/user/password/forgot',

    // Market Data
    MARKET_WATCH: '/api/v1/marketwatches',
    ALL_INDICES: '/api/v1/indices',
    ADD_INSTRUMENT: '/api/v1/marketwatches',
    DELETE_INSTRUMENT: '/api/v1/marketwatches/{id}',
    MARKET_DEPTH: '/api/v1/marketdepth/{token}',

    // Orders
    PLACE_ORDER: '/api/v1/orders',
    MODIFY_ORDER: '/api/v1/orders/{order_id}',
    CANCEL_ORDER: '/api/v1/orders/{order_id}',
    ORDER_BOOK: '/api/v1/orders',
    TRADE_BOOK: '/api/v1/trades',

    // Portfolio & Holdings
    POSITIONS: '/api/v1/positions',
    HOLDINGS: '/api/v1/holdings',

    // User Profile
    PROFILE: '/api/v1/user/profile',
    CHANGE_PASSWORD: '/api/v1/user/password/change',

    // Funds
    FUNDS: '/api/v2/funds/view',
    FUND_LIMITS: '/api/v1/funds/limits',

    // Websocket
    WEBSOCKET: '/api/v1/feed',

    // Instruments
    SEARCH_INSTRUMENTS: '/api/v1/search',
    INSTRUMENT_INFO: '/api/v1/contract',
    DASHBOARD_PINS: '/api/v1/dashboard/pins'
  }
};

export const getApiUrl = (endpoint) => {
  const config = CONFIG[ENV];
  return config.USE_PROXY ? endpoint : `${config.BASE_URL}${endpoint}`;
};

export const createAuthHeader = (token) => ({
  'Authorization': `Bearer ${token}`,
  'Content-Type': 'application/json'
});

export const getAssetUrl = (assetPath) => {
  const config = CONFIG[ENV];
  return `${config.BASE_URL}/${assetPath}`;
}; 